export const EXPAND_BEHAVIORS = {
  SLIDE_LEFT: 'slide-left',
  SLIDE_RIGHT: 'slide-right',
};
